import { AppModal } from './AppModal';
import { ForgotPasswordForm } from './ForgotPasswordForm';

export function ForgotPasswordModal(props) {
    return (
      <AppModal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        onShow={() => { document.getElementsByTagName("body")[0].style = ""; }}
      >
        <AppModal.Header>
          <div>
            <span className="h-large">F</span><span className="h-small">orgot</span>&nbsp;&nbsp;<span className="h-large">P</span><span className="h-small">assword</span>
          </div>
        </AppModal.Header>
        <AppModal.Body>
          <ForgotPasswordForm />
        </AppModal.Body>
      </AppModal>
    );
}
